import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Divider from '../../atoms/Divider';
import Text from '../../atoms/Text';

import styles from './TeacherDirectorySection.module.scss';
import usePresenter from './TeacherDirectorySection.presenter';
import getProps from './TeacherDirectorySection.props';
import { TeacherDirectorySectionCombinedProps } from './types';


const TeacherDirectorySection: React.FC<TeacherDirectorySectionCombinedProps> = (props) => {
  const {
    className,
    classes,
    text,
    divider,
    text1,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.teacherDirectorySection;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.header, classes?.header)}>
        <Text
          className={cx(styles.text, classes?.text)}
          {...internalProps.text}
          {...text}/>
        <Divider
          className={cx(styles.divider, classes?.divider)}
          {...internalProps.divider}
          {...divider}/>
      </div>
      <Text
        className={cx(styles.text1, classes?.text1)}
        {...internalProps.text1}
        {...text1}/>
      <Button
        className={cx(styles.button, classes?.button)}
        {...internalProps.button}
        {...button}/>
    </div>
  );
};

export default TeacherDirectorySection;

